import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import {ShipmentAdditionalInsurancesActions, ShipmentDirectionsActions} from '../actions';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.ShipmentAdditionalInsurance };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    ShipmentAdditionalInsurancesActions.ReadShipmentAdditionalInsurance,
    ShipmentAdditionalInsurancesActions.ReadShipmentAdditionalInsurances,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    ShipmentAdditionalInsurancesActions.ReadShipmentAdditionalInsuranceSuccess,
    (state, { response }: { response: fromModuleModels.ShipmentAdditionalInsurance }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: false
      };
    }
  ),
  on(
    ShipmentAdditionalInsurancesActions.ReadShipmentAdditionalInsurancesSuccess,
    (state, { response }) => {
      const items = response['hydra:member'];
      const entities = items.reduce(
        (
          entities: { [iri: string]: fromModuleModels.ShipmentAdditionalInsurance },
          item: fromModuleModels.ShipmentAdditionalInsurance
        ) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    ShipmentAdditionalInsurancesActions.ReadShipmentAdditionalInsuranceFail,
    ShipmentAdditionalInsurancesActions.ReadShipmentAdditionalInsurancesFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
